var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      ref: "appBar",
      class: [
        _vm.isScrolled
          ? _vm.withTabs && _vm.keepTabHeader
            ? "collapse-tab-nav"
            : "collapse-nav"
          : null,
        "nav-bar xs:pl-0 sm:pl-1 lg:pl-2",
        _vm.$page.url.includes("/explore")
          ? !_vm.isScrolled
            ? "transparent"
            : "l-blue"
          : "white",
      ],
      staticStyle: { "background-color": "white", "z-index": "9" },
      attrs: {
        app: "",
        "elevate-on-scroll": "",
        flat:
          _vm.$page.component == "Schedule" ||
          _vm.$page.url.includes("/availability"),
        prominent: "",
        height: _vm.withTabs ? "128" : "96",
      },
    },
    [
      _c(
        "div",
        {
          class: [_vm.withTabs ? "scrollUp" : null, "flex"],
          staticStyle: { height: "100%", top: "0px" },
          attrs: { id: "navbar-items-left" },
        },
        [
          _c(
            "div",
            {
              class: [
                _vm.isScrolled ? "pull-up-fade pull-up" : null,
                " flex align-center ease-fade ease",
              ],
              staticStyle: { height: "48px" },
            },
            [
              _c(
                "Link",
                { attrs: { href: "/" } },
                [
                  _c("jet-application-logo", {
                    staticClass: "block h-9 w-auto",
                    staticStyle: { height: "1rem !important" },
                    attrs: {
                      white:
                        _vm.$page.component == "Explore" && !_vm.isScrolled,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.playView
                ? _c(
                    "h6",
                    { staticClass: "text-sm text-gray-600 leading-tight mx-2" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$page.props.auth.user.selected_location.name
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("SoliHeader", {
            class: [
              "align-self-center absolute flex align-center ease",
              _vm.withTabs
                ? _vm.isScrolled
                  ? !_vm.keepTabHeader
                    ? "pull-up-fade pull-up"
                    : "pb-10"
                  : null
                : _vm.isScrolled
                ? null
                : "push-down",
            ],
            staticStyle: { height: "48px", background: "transparent" },
            attrs: {
              text: _vm.pageTitle,
              href: _vm.$page.props.staffView ? _vm.backLink : null,
              large: !_vm.$page.props.staffView,
              headerButton: _vm.headerButton,
              sandwich: _vm.sandwich,
              isScrolled: _vm.isScrolled,
            },
            on: {
              sandwich: function ($event) {
                return _vm.$emit("sandwich")
              },
              headerButton: function ($event) {
                return _vm.$emit("headerButton")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [_vm._t("title")]
                  },
                  proxy: true,
                },
                {
                  key: "tools",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            "flex justify-end pr-3 py-3 custom absolute right-4",
                            _vm.isScrolled ? "top-5" : "top-9",
                          ],
                        },
                        [
                          (_vm.$page.component == "Store"
                            ? _vm.$vuetify.breakpoint.width < 1150
                            : _vm.$vuetify.breakpoint.xs) && _vm.showPageSearch
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex align-center",
                                  staticStyle: { "z-index": "12" },
                                },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        left: "",
                                        "close-on-content-click": false,
                                        "content-class": "white",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "elevation-3",
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "soli-blue-text text-shadow-blue",
                                                      },
                                                      [_vm._v("filter_list")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        562875708
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "mobilePageSearch",
                                        staticClass: "pb-3 mr-3 pl-4 mt-0",
                                        staticStyle: { "min-width": "200px" },
                                        attrs: {
                                          width: "200",
                                          label: "Search",
                                          "single-line": "",
                                          clearable: "",
                                          autofocus: "",
                                          "append-icon": _vm.searchBinding
                                            ? null
                                            : "filter_list",
                                          "hide-details": "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.$emit(
                                              "pageSearch",
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.searchBinding,
                                          callback: function ($$v) {
                                            _vm.searchBinding = $$v
                                          },
                                          expression: "searchBinding",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.$page.component == "Store"
                            ? _vm.$vuetify.breakpoint.width > 1150
                            : _vm.$vuetify.breakpoint.smAndUp) &&
                          _vm.showPageSearch
                            ? _c(
                                "div",
                                {
                                  class: [
                                    "mr-1",
                                    _vm.isScrolled ? "top-5" : "top-8",
                                  ],
                                  staticStyle: {
                                    "z-index": "12",
                                    width: "200px",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "pl-6",
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: "Search",
                                      "single-line": "",
                                      "hide-details": "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.$emit("pageSearch", $event)
                                      },
                                    },
                                    model: {
                                      value: _vm.searchBinding,
                                      callback: function ($$v) {
                                        _vm.searchBinding = $$v
                                      },
                                      expression: "searchBinding",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$page.component == "People" &&
                          _vm.$page.url.includes("students")
                            ? _c(
                                "div",
                                { staticClass: "flex align-center" },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        left: "",
                                        "close-on-content-click": false,
                                        "content-class": "white",
                                        "max-width": "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "elevation-3 ml-2",
                                                        staticStyle: {
                                                          "z-index": "12",
                                                        },
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-badge", {
                                                      staticStyle: {
                                                        position:
                                                          "absolute !important",
                                                        top: "0px",
                                                        right: "0px",
                                                      },
                                                      attrs: {
                                                        value:
                                                          !_vm.showAllStudents,
                                                        color: "primary",
                                                        dot: "",
                                                        overlap: "",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "soli-blue-text text-shadow-blue",
                                                      },
                                                      [_vm._v("more_vert")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        808581430
                                      ),
                                      model: {
                                        value: _vm.peopleOptions,
                                        callback: function ($$v) {
                                          _vm.peopleOptions = $$v
                                        },
                                        expression: "peopleOptions",
                                      },
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c(
                                            "v-list-item",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "flex soli-round soli-grey",
                                                  attrs: {
                                                    ripple: false,
                                                    outlined: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.handleShowAllStudents(
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "small",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          "Active Students"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.showAllStudents
                                                            ? null
                                                            : "accent",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.showAllStudents
                                                            ? "toggle_off"
                                                            : "toggle_on"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item",
                                            [
                                              _c("v-select", {
                                                staticClass: "soli-round",
                                                attrs: {
                                                  dense: "",
                                                  label: "Retention Group",
                                                  "hide-details": "",
                                                  outlined: "",
                                                  clearable: "",
                                                  items: [
                                                    "< 90 days",
                                                    "3 months",
                                                    "6 months",
                                                    "12 months",
                                                    "24 months",
                                                    "36 months",
                                                  ],
                                                  value: _vm.retentionGroup,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.handleRetentionGroup(
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$page.component == "People" &&
                          _vm.$page.url.includes("teachers")
                            ? _c(
                                "div",
                                { staticClass: "flex align-center" },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        left: "",
                                        "close-on-content-click": false,
                                        "content-class": "white",
                                        "max-width": "212",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "elevation-3 ml-2",
                                                        staticStyle: {
                                                          "z-index": "12",
                                                        },
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-badge", {
                                                      staticStyle: {
                                                        position:
                                                          "absolute !important",
                                                        top: "0px",
                                                        right: "0px",
                                                      },
                                                      attrs: {
                                                        value:
                                                          (_vm.nearMe &&
                                                            _vm.can(
                                                              "Access all locations"
                                                            )) ||
                                                          (_vm.selectedMarket &&
                                                            _vm.can(
                                                              "Access all locations"
                                                            )) ||
                                                          !_vm.showArchived,
                                                        color: "primary",
                                                        dot: "",
                                                        overlap: "",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "soli-blue-text text-shadow-blue",
                                                      },
                                                      [_vm._v("more_vert")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1560177750
                                      ),
                                      model: {
                                        value: _vm.peopleOptions,
                                        callback: function ($$v) {
                                          _vm.peopleOptions = $$v
                                        },
                                        expression: "peopleOptions",
                                      },
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c(
                                            "v-list-item",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "flex soli-round soli-grey",
                                                  attrs: {
                                                    ripple: false,
                                                    outlined: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.handleShowArchived()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "small",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _vm._v(
                                                        "\n                                            Active Teachers\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: _vm.showArchived
                                                          ? null
                                                          : "accent",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.showArchived
                                                            ? "toggle_off"
                                                            : "toggle_on"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.can("Access all locations")
                                            ? _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "flex soli-round soli-grey",
                                                      attrs: {
                                                        ripple: false,
                                                        outlined: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleNearMe(
                                                            true
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$page.props
                                                                .auth.user
                                                                .selected_location
                                                                .name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: _vm.nearMe
                                                              ? "accent"
                                                              : null,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nearMe
                                                                ? "toggle_on"
                                                                : "toggle_off"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.can("Access all locations")
                                            ? _c(
                                                "v-list-item",
                                                [
                                                  _c("v-select", {
                                                    staticClass: "soli-round",
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Market",
                                                      "hide-details": "",
                                                      dense: "",
                                                      items: _vm.marketOptions,
                                                      "item-text": "name",
                                                      "item-value": "id",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleNearMe(
                                                          false
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.selectedMarket,
                                                      callback: function ($$v) {
                                                        _vm.selectedMarket = $$v
                                                      },
                                                      expression:
                                                        "selectedMarket",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showFilter
                        ? _c(
                            "v-col",
                            {
                              class: [
                                "flex justify-end mr-3 custom absolute top-8 right-0",
                                _vm.$vuetify.breakpoint.xs && _vm.activateFilter
                                  ? "col-10"
                                  : "col-2",
                              ],
                              staticStyle: { "z-index": "12" },
                              attrs: { sm: "6" },
                            },
                            [
                              _c("v-combobox", {
                                ref: "comboFilter",
                                staticClass: "align-self-start custom",
                                attrs: {
                                  value: _vm.filterData ? _vm.filterData : [],
                                  items: _vm.filterData ? _vm.filterData : [],
                                  "item-text": "name",
                                  "item-value": "id",
                                  chips: "",
                                  dense: "",
                                  multiple: "",
                                  "hide-details": "",
                                  "menu-props": {
                                    auto: true,
                                    maxHeight: "unset",
                                  },
                                  "append-icon": "",
                                  label: "Filter",
                                  "single-line": "",
                                  flat: "",
                                  reverse: "",
                                  color: "dark",
                                  "background-color": "transparent",
                                  filled: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("filterResults", $event)
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm.$vuetify.breakpoint.smAndUp
                                            ? _c(
                                                "v-chip",
                                                _vm._b(
                                                  {
                                                    key: JSON.stringify(
                                                      data.item.id
                                                    ),
                                                    attrs: {
                                                      "input-value":
                                                        data.selected,
                                                      close: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      "click:close": function (
                                                        $event
                                                      ) {
                                                        ;[
                                                          data.parent.selectItem(
                                                            data.item
                                                          ),
                                                          data.parent.blur(),
                                                          (_vm.activateFilter = false),
                                                        ]
                                                      },
                                                    },
                                                  },
                                                  "v-chip",
                                                  data.attrs,
                                                  false
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        data.item.first_name
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3681578277
                                ),
                              }),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "align-self-center shadow-blue plain mr-2",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilter()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("filter_list")])],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [_vm._t("actions")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "absolute",
            _vm.isScrolled && !_vm.keepTabHeader
              ? "align-self-center"
              : "align-self-end",
            _vm.$page.component == "Store" && _vm.$vuetify.breakpoint.xs
              ? "filter-space"
              : "w-full",
          ],
        },
        [_vm._t("tabs")],
        2
      ),
      _vm._v(" "),
      _vm.playView &&
      !_vm.$vuetify.breakpoint.smAndDown &&
      _vm.$page.component !== "Login" &&
      _vm.$page.props.auth.user
        ? _c(
            "div",
            {
              staticClass: "flex absolute w-full justify-center",
              attrs: { id: "navbar-items-center" },
            },
            [
              _c(
                "div",
                { staticClass: "py-1" },
                [
                  !_vm.$page.props.auth.user.virtual_client
                    ? _c(
                        "Link",
                        {
                          staticClass: "text-lg ml-1.5 pb-3",
                          attrs: { href: "/explore" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "px-2",
                              class: [
                                _vm.$page.component == "Explore"
                                  ? "font-weight-bold"
                                  : "font-weight-light",
                              ],
                              staticStyle: {
                                "text-transform": "none !important",
                                "letter-spacing": "normal",
                              },
                              attrs: {
                                rounded: "",
                                text: "",
                                color:
                                  _vm.$page.component == "Explore" &&
                                  !_vm.isScrolled
                                    ? "white"
                                    : "primary",
                              },
                            },
                            [
                              _c("span", { staticClass: "text-lg" }, [
                                _vm._v("Explore"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "Link",
                    {
                      staticClass: "text-lg ml-1.5 pb-3",
                      attrs: { href: "/myschedule" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-2",
                          class: [
                            _vm.$page.component == "MySchedule"
                              ? "font-weight-bold"
                              : "font-weight-light",
                          ],
                          staticStyle: {
                            "text-transform": "none !important",
                            "letter-spacing": "normal",
                          },
                          attrs: {
                            rounded: "",
                            text: "",
                            color:
                              _vm.$page.component == "Explore" &&
                              !_vm.isScrolled
                                ? "white"
                                : "primary",
                          },
                        },
                        [
                          _c("span", { staticClass: "text-lg" }, [
                            _vm._v("Lessons"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Link",
                    {
                      staticClass: "text-lg ml-1.5 pb-3",
                      attrs: { href: "/inbox" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-2",
                          class: [
                            _vm.$page.component == "Inbox"
                              ? "font-weight-bold"
                              : "font-weight-light",
                          ],
                          staticStyle: {
                            "text-transform": "none !important",
                            "letter-spacing": "normal",
                          },
                          attrs: {
                            rounded: "",
                            text: "",
                            color:
                              _vm.$page.component == "Explore" &&
                              !_vm.isScrolled
                                ? "white"
                                : "primary",
                          },
                        },
                        [
                          _c(
                            "v-badge",
                            {
                              attrs: {
                                content: _vm.$page.props.unreadMessageCount,
                                color: _vm.$page.props.unreadMessageCount
                                  ? "soli-red"
                                  : null,
                                "offset-y": "8",
                              },
                            },
                            [
                              _c("span", { staticClass: "text-lg" }, [
                                _vm._v("Inbox"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Link",
                    {
                      staticClass: "text-lg ml-1.5 pb-3",
                      attrs: { href: "/help-categories" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-2",
                          class: [
                            _vm.$page.component == "HelpCategory/Index"
                              ? "font-weight-bold"
                              : "font-weight-light",
                          ],
                          staticStyle: {
                            "text-transform": "none !important",
                            "letter-spacing": "normal",
                          },
                          attrs: {
                            rounded: "",
                            text: "",
                            color:
                              _vm.$page.component == "Explore" &&
                              !_vm.isScrolled
                                ? "white"
                                : "primary",
                          },
                        },
                        [
                          _c("span", { staticClass: "text-lg" }, [
                            _vm._v("Help"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex justify-end align-center -mr-2 z-40 flex-grow-0",
          class: {
            "gap-2": _vm.$vuetify.breakpoint.smAndUp,
            "align-self-center": !_vm.keepTabHeader && _vm.isScrolled,
            "pa-1": _vm.playView,
            white: _vm.$page.component !== "Explore",
          },
          attrs: { id: "navbar-items-right" },
        },
        [
          !_vm.$page.props.auth.user
            ? _c(
                "SoliBtn",
                {
                  staticClass: "my-2.5",
                  attrs: {
                    href: "/login",
                    color: "white",
                    textColor: "soli-grey",
                  },
                },
                [_vm._v("Login")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$page.props.staffView &&
          (_vm.$vuetify.breakpoint.smAndDown ||
            _vm.$page.component == "Store") &&
          (_vm.$page.component !== "Store" ||
            (_vm.$page.component == "Store" && !_vm.isScrolled))
            ? _c(
                "v-dialog",
                {
                  ref: "mobileSearch",
                  attrs: { "max-width": "400" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "items-center",
                                    attrs: { icon: "", medium: "" },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass:
                                      "soli-blue-text text-shadow-blue",
                                  },
                                  [_vm._v("search")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1630331508
                  ),
                  model: {
                    value: _vm.showSearch,
                    callback: function ($$v) {
                      _vm.showSearch = $$v
                    },
                    expression: "showSearch",
                  },
                },
                [
                  _vm._v(" "),
                  _vm.showSearch
                    ? _c("GlobalSearch", {
                        ref: "globalSearch",
                        staticClass: "px-3 top-9 left-0",
                        staticStyle: { position: "absolute" },
                        attrs: { showMacros: _vm.showMacros, mobile: "" },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$page.props.staffView &&
          _vm.$vuetify.breakpoint.mdAndUp &&
          _vm.$page.component !== "Store"
            ? _c("GlobalSearch", {
                ref: "globalSearch",
                staticClass: "mx-2",
                attrs: { showMacros: _vm.showMacros },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.can("Work") &&
          !_vm.playView &&
          _vm.can("Create students") &&
          (_vm.$page.component !== "Store" ||
            (_vm.$page.component == "Store" && !_vm.isScrolled))
            ? _c(
                "v-btn",
                {
                  attrs: { icon: "", medium: "" },
                  on: {
                    click: function ($event) {
                      _vm.userCreate = true
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "soli-blue-text text-shadow-blue" },
                    [_vm._v("person_add")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$page.props.auth.user &&
          (_vm.$page.component !== "Store" ||
            (_vm.$page.component == "Store" && !_vm.isScrolled))
            ? _c("Notifications")
            : _vm._e(),
          _vm._v(" "),
          _vm.can("Work") &&
          !_vm.playView &&
          _vm.$page.component == "Store" &&
          _vm.cart > 0 &&
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-btn",
                {
                  attrs: { icon: "", medium: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("showCart")
                    },
                  },
                },
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        color: "accent",
                        content: _vm.cart,
                        overlap: "",
                        bordered: "",
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "soli-blue-text text-shadow-blue" },
                        [_vm._v("local_offer")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.$vuetify.breakpoint.mdAndUp &&
                    _vm.$page.props.auth.user,
                  expression:
                    "$vuetify.breakpoint.mdAndUp && $page.props.auth.user",
                },
              ],
              staticClass: "ml-3",
              attrs: { id: "profile-settings-dropdown" },
            },
            [
              _c("jet-dropdown", {
                staticStyle: { "z-index": "100" },
                attrs: { align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "!rounded-full",
                            staticStyle: { "padding-right": "2px" },
                            attrs: { rounded: "", color: "white" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "my-auto",
                                    attrs: { left: "", color: "dark" },
                                  },
                                  [_vm._v("menu")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-avatar",
                                  { attrs: { size: "32" } },
                                  [
                                    _c("v-img", {
                                      attrs: {
                                        width: "32",
                                        height: "32",
                                        src: _vm.$page.props.auth.user
                                          .profile_photo_path
                                          ? `/api/image-service/40x40/${_vm.$page.props.auth.user.profile_photo_path}`
                                          : _vm.$page.props.auth.user
                                              .profile_photo_url,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _vm.is("Admin") && !_vm.playView
                          ? _c(
                              "div",
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                    attrs: { href: "/admin" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Admin Panel\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-divider"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "jet-dropdown-link",
                          {
                            attrs: {
                              href: `/profile/${_vm.$page.props.auth.user.id}/account`,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        View Profile\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.playView
                          ? _c(
                              "jet-dropdown-link",
                              { attrs: { as: "button" } },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: "/update-billing" } },
                                  [
                                    _vm._v(
                                      "\n                            Manage Payment Methods"
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-divider"),
                        _vm._v(" "),
                        _vm.$page.props.staffView && _vm.is("Teacher")
                          ? _c(
                              "jet-dropdown-link",
                              {
                                attrs: {
                                  href: `/profile/${_vm.$page.props.auth.user.id}/availability`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Manage Availability\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$page.props.canWorkSummary
                          ? _c(
                              "div",
                              [
                                _vm.$page.props.canWorkSummary &&
                                _vm.$page.props.auth.user.locations.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit("locationSelect")
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "flex soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "locationSelect"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$page.props.auth.user
                                                    .selected_location.name
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "primary",
                                                },
                                              },
                                              [_vm._v("my_location")]
                                            ),
                                            _vm._v(" "),
                                            _vm.showMacros
                                              ? _c(
                                                  "div",
                                                  { staticClass: "px-1" },
                                                  [
                                                    _vm._v(
                                                      "\n                                    + L\n                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.can("Work")
                                  ? _c("div", { on: { click: _vm.setView } }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "flex soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Student View\n                                "
                                          ),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: { height: "20px" },
                                              attrs: {
                                                color: _vm.toggleView
                                                  ? "dark"
                                                  : "accent",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.toggleView
                                                    ? "toggle_off"
                                                    : "toggle_on"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showMacros
                                            ? _c(
                                                "div",
                                                { staticClass: "px-1" },
                                                [
                                                  _vm._v(
                                                    "\n                                    + M\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.can("Use time clock") &&
                                _vm.$page.props.staffView
                                  ? _c(
                                      "div",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.showTimeClock = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "flex align-center soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Time Clock\n                                "
                                            ),
                                            _vm.$page.props.currentTimeClock
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "animate__animated animate__pulse animate__repeat-3 justify-end flex",
                                                    attrs: {
                                                      right: "",
                                                      small: "",
                                                      color: "error",
                                                    },
                                                  },
                                                  [_vm._v("timer")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-divider"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                _vm.composeEmail = true
                              },
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                              },
                              [
                                _vm._v(
                                  "\n                            Share Feedback"
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out",
                            attrs: {
                              href: "https://musicologie.app/privacy",
                              target: "_blank",
                            },
                          },
                          [_vm._v("Privacy Policy")]
                        ),
                        _vm._v(" "),
                        _c("v-divider"),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.logout.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "jet-dropdown-link",
                              {
                                staticClass: "error--text",
                                attrs: { as: "button" },
                              },
                              [
                                _vm._v(
                                  "\n                            Logout\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.userCreate
        ? _c("UserCreate", {
            attrs: { errors: _vm.$page.props.errors },
            on: { reset: _vm.reset, success: _vm.reset },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTimeClock
        ? _c("TimeClock", {
            attrs: { user: _vm.$page.props.auth.user },
            on: {
              success: function ($event) {
                return _vm.$emit("success")
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.showTimeClock = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: ["feedback@musicologie.com"],
              errors: _vm.errors,
              user: _vm.$page.props.auth.user,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }